module.exports = __webpack_public_path__ + "static/media/logo-light-192.87498308.png";